module.exports = __webpack_public_path__ + "encs/web_store/avpv/img/folder-computer.f6b08156.svg";